import React from 'react';
import { Typography } from 'antd';
import { useThemeStyles } from '../context/ThemeContext';

const { Title } = Typography;

/**
 * Standard page header: title (left) + actions (right).
 */
export default function PageHeader({
  title,
  actions = null,
  style,
  className = '',
}) {
  const themeStyles = useThemeStyles();

  return (
    <header
      className={`page-header ${className}`.trim()}
      style={{
        marginBottom: 18,
        ...style,
      }}
    >
      <div
        className="page-header__row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 12,
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        <Title
          level={2}
          className="page-header__title"
          style={{
            margin: 0,
            padding: 0,
            color: themeStyles.textPrimary,
            fontSize: 26,
            fontWeight: 600,
            lineHeight: 1.25,
            flex: '1 1 auto',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {title}
        </Title>
        {actions ? (
          <div
            className="page-header__actions"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              flexShrink: 0,
              margin: 0,
            }}
          >
            {actions}
          </div>
        ) : null}
      </div>
    </header>
  );
}
